import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "@/hooks/useTranslation";
import { useRouteLocale } from "@/hooks/useRouteLocale";
import { PUBLIC_ROUTES } from "@/routes/public";
import { LanguageSwitcher } from "@/components/common/LanguageSwitcher";
import { FooterLinkColumns } from "@/components/common/FooterLinkColumns";

/** Header and footer for the static public content pages (blog, FAQ). */
export function PublicContentLayout({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const locale = useRouteLocale();

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <header className="border-b bg-background/95">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between gap-4">
          <Link
            to={PUBLIC_ROUTES.home(locale)}
            className="font-bold font-logo bg-gradient-to-r from-pink-500 to-rose-500 bg-clip-text text-transparent text-3xl whitespace-nowrap px-1"
          >
            {t("header.logo")}
          </Link>
          <LanguageSwitcher compact />
        </div>
      </header>

      <main className="flex-1 container mx-auto px-4 py-10 max-w-3xl">{children}</main>

      <footer className="border-t" style={{ backgroundImage: "linear-gradient(to right bottom, rgb(255, 250, 250), rgba(249, 236, 238, 0.2))" }}>
        <div className="container mx-auto px-4 py-12">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
            <div>
              <p className="font-logo text-2xl font-bold bg-gradient-to-r from-pink-500 to-rose-500 bg-clip-text text-transparent mb-2">
                {t("header.logo")}
              </p>
              <p className="text-sm text-muted-foreground">{t("footer.mission")}</p>
            </div>
            <FooterLinkColumns />
          </div>
          <div className="mt-12 pt-8 border-t border-border">
            <p className="text-sm text-muted-foreground">
              {t("footer.copyright", { year: String(new Date().getFullYear()) })}
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
